import type { RoleData } from "../contexts/RoleContext";

export const getDashboardRouteForRole = (activeRole: RoleData | null): string => {
  if (activeRole?.role === "executor" && activeRole.estateOwnerId) {
    return `/executor-plan/${activeRole.estateOwnerId}/eframe-141`;
  }

  if (activeRole?.role === "planner") {
    return "/frame-140";
  }

  return "/estate-selector";
};
